var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.979,
    height: 24.651,
    viewBox: "0 0 18.979 24.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_30",
    "data-name": "Union 30",
    d: "M17826.873-3966.347a.726.726,0,0,1-.725-.73.725.725,0,0,1,.725-.725h4.338a.729.729,0,0,1,.73.725.73.73,0,0,1-.73.73Zm-6.033-2.153c-.848,0-.973-.824-.73-1.6a13.755,13.755,0,0,0,.877-4.575v-4.427a7.9,7.9,0,0,1,6.545-7.718v-1.719a1.455,1.455,0,0,1,1.455-1.455,1.455,1.455,0,0,1,1.455,1.455v1.719a7.893,7.893,0,0,1,6.545,7.718v4.427a13.677,13.677,0,0,0,.883,4.575c.236.779.111,1.6-.734,1.6Z",
    transform: "translate(-17819.498 3990.498)",
    fill: "#22c",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.88a1d9bc6ba45ebbc46d4494a41aa624.svg";
export { ForwardRef as ReactComponent };